// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `figure {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 5%;
    margin-inline-end: 5%;
  }
  figure > img {
    width: inherit;
    height: inherit;
  }
  figure[class~='table'] {
    margin: 1em auto;
  }
  figure[class~='table'] table {
      width: 100%;
      height: 100%;
    }
  thead, th {
    background-color: #d9d9d944;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }
  td {
    background-color: #fafafa66;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }
  figcaption {
    font-family: Calibri, 'Trebuchet MS', sans-serif;
    font-style: italic;
    color: rgba(0, 0, 0, 0.6);
    background-color: rgba(0, 0, 0, 0.05);
    padding: 5px;
    border-radius: 0 0 4px 4px;
    margin-top: -5px;
    display: block !important;
  }
  .ck-editor {
    display: flex;
    flex-direction: column;
    width: 100% !important;
    height: 100% !important;
  }
  .ck-content {
    max-height: 100%;
    min-height: 120px;
    height: 100%;
  }
  .ck-editor__editable {
    padding: 0px 10px !important;
  }
  .ck-editor__top {
    display: table-header-group;
  }
  .ck-editor__main {
    height: calc(100% - 40px) !important;
    display: table-cell;
    font-family: 'Noto Sans';
  }
  .ck-list__item {
    background-color: #ffffff;
  }
  .ck.ck-balloon-panel {
    z-index: 1500 !important;
  }
  .ck.ck-labeled-input {
    z-index: 1600 !important;
  }
  .ck-validators-error {
    box-shadow: 0 0 3px #e56d7a;
    border: 1px solid #e56d7a;
    border-radius: 3px;
  }
  .ck-validators-error-label {
    display: flex;
    justify-content: flex-end;
  }
  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible {
    z-index: 1;
  }
  .image {
    display: inline-block !important;
    position: relative;
    clear: both;
    text-align: center;
    margin: 1em !important;
  }
  .image-style-align-center {
    /* margin-left: auto !important;
    margin-right: auto !important; */
    margin: 1em auto !important;
    display: block !important;
  }
  .image-style-align-left {
    float: left;
  }
  .image-style-align-right {
    float: right;
  }
  .image-style-align-center, .image-style-align-left, .image-style-align-right, .image-style-side {
    max-width: 50%;
    padding: 0 10px;
  }
`, "",{"version":3,"sources":["webpack://./app/components/TextEditor/editor.module.scss"],"names":[],"mappings":"AACE;IACE,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;EACvB;EAEA;IACE,cAAc;IACd,eAAe;EACjB;EAEA;IACE,gBAAgB;EAMlB;EAJE;MACE,WAAW;MACX,YAAY;IACd;EAGF;IAEE,2BAA2B;IAC3B,qCAAqC;EACvC;EAEA;IACE,2BAA2B;IAC3B,qCAAqC;EACvC;EAEA;IACE,gDAAgD;IAChD,kBAAkB;IAClB,yBAAyB;IACzB,qCAAqC;IACrC,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;EAC3B;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;EAEA;IACE,4BAA4B;EAC9B;EAEA;IACE,2BAA2B;EAC7B;EAEA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,wBAAwB;EAC1B;EAEA;IACE,yBAAyB;EAC3B;EAEA;IACE,wBAAwB;EAC1B;EAEA;IACE,wBAAwB;EAC1B;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;EACpB;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;EAEA;IACE,UAAU;EACZ;EAEA;IACE,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;EACxB;EAEA;IACE;oCACgC;IAChC,2BAA2B;IAC3B,yBAAyB;EAC3B;EAEA;IACE,WAAW;EACb;EAEA;IACE,YAAY;EACd;EAEA;IAIE,cAAc;IACd,eAAe;EACjB","sourcesContent":[":global {\n  figure {\n    display: block;\n    margin-block-start: 1em;\n    margin-block-end: 1em;\n    margin-inline-start: 5%;\n    margin-inline-end: 5%;\n  }\n\n  figure > img {\n    width: inherit;\n    height: inherit;\n  }\n\n  figure[class~='table'] {\n    margin: 1em auto;\n\n    table {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  thead,\n  th {\n    background-color: #d9d9d944;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  td {\n    background-color: #fafafa66;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  figcaption {\n    font-family: Calibri, 'Trebuchet MS', sans-serif;\n    font-style: italic;\n    color: rgba(0, 0, 0, 0.6);\n    background-color: rgba(0, 0, 0, 0.05);\n    padding: 5px;\n    border-radius: 0 0 4px 4px;\n    margin-top: -5px;\n    display: block !important;\n  }\n\n  .ck-editor {\n    display: flex;\n    flex-direction: column;\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .ck-content {\n    max-height: 100%;\n    min-height: 120px;\n    height: 100%;\n  }\n\n  .ck-editor__editable {\n    padding: 0px 10px !important;\n  }\n\n  .ck-editor__top {\n    display: table-header-group;\n  }\n\n  .ck-editor__main {\n    height: calc(100% - 40px) !important;\n    display: table-cell;\n    font-family: 'Noto Sans';\n  }\n\n  .ck-list__item {\n    background-color: #ffffff;\n  }\n\n  .ck.ck-balloon-panel {\n    z-index: 1500 !important;\n  }\n\n  .ck.ck-labeled-input {\n    z-index: 1600 !important;\n  }\n\n  .ck-validators-error {\n    box-shadow: 0 0 3px #e56d7a;\n    border: 1px solid #e56d7a;\n    border-radius: 3px;\n  }\n\n  .ck-validators-error-label {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible {\n    z-index: 1;\n  }\n\n  .image {\n    display: inline-block !important;\n    position: relative;\n    clear: both;\n    text-align: center;\n    margin: 1em !important;\n  }\n\n  .image-style-align-center {\n    /* margin-left: auto !important;\n    margin-right: auto !important; */\n    margin: 1em auto !important;\n    display: block !important;\n  }\n\n  .image-style-align-left {\n    float: left;\n  }\n\n  .image-style-align-right {\n    float: right;\n  }\n\n  .image-style-align-center,\n  .image-style-align-left,\n  .image-style-align-right,\n  .image-style-side {\n    max-width: 50%;\n    padding: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
